import { Box, Container } from '@mui/material'
import { StowageInstructionForm } from '@storage/features/stowage-instruction/components/organisms/StowageInstructionForm'
import { StowageInstructionFormHeader } from '@storage/features/stowage-instruction/components/organisms/StowageInstructionFormHeader'
import { useStowageInstructionMessageHandler } from '@storage/features/stowage-instruction/hooks/useStowageInstructionMessageHandler'
import { IStowageInstructionFormData } from '@storage/features/stowage-instruction/models/stowage-instruction.model'
import { useStorageStore } from '@storage/index'

import { useMinimalsTheme } from '@tom-ui/ui'
import { appStore, PATHS, useAsyncFetch, useFormStore, withAuthenticationRequired } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { useNavigate, useParams } from 'react-router'

export const StowageInstructionFormPage = withAuthenticationRequired(
  observer(() => {
    const theme = useMinimalsTheme()
    const { id } = useParams<{ id: string }>()
    const navigate = useNavigate()
    const { stowageInstructionStore: store } = useStorageStore()
    const { getExceptionMessage, getSuccessMessage } = useStowageInstructionMessageHandler()
    const formStore = useFormStore<IStowageInstructionFormData>()

    const stowageInstructionId = id ?? null

    useAsyncFetch(
      async () => {
        await store.fetchData()
        store.setSelectedStowageInstruction(store.entries.find(x => x.id === stowageInstructionId))
      },
      [stowageInstructionId, store],
      { onError: error => appStore.setShowAlert('error', getExceptionMessage(error)) },
    )

    const onSubmit = async () => {
      try {
        const data: IStowageInstructionFormData = formStore.data

        if (formStore.validate()) {
          if (stowageInstructionId && stowageInstructionId !== 'add')
            await store.updateStowageInstruction({
              ...data,
              id: stowageInstructionId,
            })
          else await store.createStowageInstruction(data)

          appStore.setShowAlert('success', getSuccessMessage())
          navigate(PATHS.masterData.stowageInstruction.url)
          store.setSelectedStowageInstruction(undefined)
        }
      } catch (error) {
        appStore.setShowAlert('error', getExceptionMessage(error))
      }
    }

    return (
      <Box
        sx={{
          bgcolor: theme.palette.grey[100],
          minHeight: '100%',
        }}
      >
        <StowageInstructionFormHeader
          isEdit={!!stowageInstructionId && stowageInstructionId !== 'add'}
          onSubmit={onSubmit}
        />

        <Container sx={{ paddingY: 2 }}>
          {(stowageInstructionId === store.selectedStowageInstruction?.id ||
            (stowageInstructionId === 'add' && !store.selectedStowageInstruction)) && (
            <StowageInstructionForm
              formStore={formStore}
              stowageInstruction={store.selectedStowageInstruction}
              stowageInstructionNames={store.stowageInstructionNames}
            />
          )}
        </Container>
      </Box>
    )
  }),
)
